export default "__VITE_ASSET__bb2Vrugg__"